import { render, staticRenderFns } from "./ChatSendMessageForm.vue?vue&type=template&id=7282ab0c&scoped=true&"
import script from "./ChatSendMessageForm.vue?vue&type=script&lang=ts&"
export * from "./ChatSendMessageForm.vue?vue&type=script&lang=ts&"
import style0 from "./ChatSendMessageForm.vue?vue&type=style&index=0&id=7282ab0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7282ab0c",
  null
  
)

export default component.exports